import React from "react";
import styled from "styled-components";

const TroniqContainer = styled.section`
  width: 100%;
  padding: 50px 20px;
  background: linear-gradient(90deg, #ff5722, #d32f2f);
  box-sizing: border-box;
  text-align: center;
`;

const TroniqTitel = styled.h2`
  font-size: 36px;
  color: #ffffff;
  margin-bottom: 20px;
`;

const TroniqText = styled.p`
  font-size: 18px;
  color: #f5f5f5;
  margin-bottom: 30px;
`;

const TroniqButton = styled.a`
  display: inline-block;
  padding: 15px 30px;
  background-color: #ff7043;
  color: #ffffff;
  font-size: 20px;
  font-weight: bold;
  text-decoration: none;
  border-radius: 8px;
  transition: background-color 0.3s;

  &:hover {
    background-color: #ff5722;
  }
`;

const CTA = () => {
  return (
    <TroniqContainer>
      <TroniqTitel>Bereit, Ihre Plattform zu transformieren?</TroniqTitel>
      <TroniqText>
        Treten Sie Troniq.news bei und entdecken Sie innovative KI-Lösungen, die Ihre Möglichkeiten erweitern.
      </TroniqText>
      <TroniqButton href="/kontakt">Kontaktieren Sie uns jetzt</TroniqButton>
    </TroniqContainer>
  );
};

export default CTA;